export default "__VITE_ASSET__yg_PKZXT__"